import * as $ from 'jquery';
import { Map } from 'immutable';
import * as path from 'shared/path';

import { IEventAggregator } from 'common/eventaggregator';
import { Observable } from 'common/barrels/rx';
import { loadScriptFile } from 'common/script';
import { IViewProvider } from 'shared/viewprovider';
import { identifyControls } from 'shared/viewlogic';
import { registeredBindings } from 'runtime/bindingengine';
import { RuntimeInfoRequested } from 'runtime/events/runtimeinforequested';
import { RuntimeCustomControlInfo } from 'runtime/data/runtimeinfo';

function loadModule(fileName: string, module: string, dependencies: string[], version: string): Observable<{}> {
    const deps = dependencies.length === 0 ? Observable.of({}) : Observable.zip(...dependencies.map(x => loadScriptFile(`custom/controls/runtime/${x}?v=${version}`, true)));
    return deps.mergeMap(() => loadScriptFile(`custom/controls/runtime/${fileName}?v=${version}`, true).do(() => (<any>window).load(module)));
}

export class ViewProvider implements IViewProvider {
    private cache = Map<string, string>();

    constructor(public resourcesVersion: string) { }

    getView(events: IEventAggregator, definitionName: string, definitionVersion: string, viewName: string, callback: (string) => void) {
        var cacheKey = `${definitionName}|${definitionVersion}|${viewName}`;

        if (this.cache.has(cacheKey)) {
            // this path does not require control loading checks, as making it into the cache ensures controls are loaded
            callback(this.cache.get(cacheKey));
        } else {
            const viewPath = viewName.indexOf('/') > -1
                ? path.sharedView(viewName, this.resourcesVersion)
                : path.view(definitionName, definitionVersion, viewName, this.resourcesVersion);

            $.get(viewPath, view => {
                const missingControls = identifyControls(view).subtract(registeredBindings().keySeq().toOrderedSet()).toArray();

                if (missingControls.length > 0) {
                    const runtimeInfo = new RuntimeInfoRequested();
                    events.publish(runtimeInfo);    
                    const infoMap = Map<RuntimeCustomControlInfo>(<any>runtimeInfo.value.customControlInfo.map(x =>[x.name, x]));
                    
                    missingControls.filter(x => ! infoMap.has(x)).forEach(x => console.log(`Missing registration for custom control \"${x}\" in view \"${viewName}\" for definition \"${definitionName}\"`));

                    // not happy with the lack of subscription disposal here... but it comes back to the callback passed in and this call not returning an observable
                    // the proper solution should be to remodel the entire thing and update all call sites to unsubscribe if they become disinterested in the result of the call
                    Observable.zip(...missingControls.map(x => infoMap.get(x)).map(x => loadModule(x.file, x.module, x.dependencies, runtimeInfo.value.version)))
                        .subscribe(x => {
                            this.cache = this.cache.set(cacheKey, view);
                            callback(view);
                    });
                }
                else {
                    this.cache = this.cache.set(cacheKey, view);                
                    callback(view);
                }
            });
        }
    }

    dispose() {
    }
}